import React from 'react'
import PropTypes from 'prop-types'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import ChevronLeft from '@material-ui/icons/ChevronLeft'
import ChevronRight from '@material-ui/icons/ChevronRight'
import i18n from '../../../assets/i18n'
import * as S from './styled'

const MAX_VISIBLE_PAGES = 5

// Réplica de TablePagination del Storybook de Velora (hrbf_freezer/src/ui/components/Table)
// para usar como components.Pagination de material-table: material-table la pinta dentro de
// un <tr>, por eso el contenedor es una celda.
const MTPagination = ({ count, page, rowsPerPage, rowsPerPageOptions, onChangePage, onChangeRowsPerPage, labelDisplayedRows, SelectProps }) => {
  const totalPages = Math.max(0, Math.ceil(count / rowsPerPage))
  let startPage = Math.max(0, page - Math.floor(MAX_VISIBLE_PAGES / 2))
  const endPage = Math.min(totalPages - 1, startPage + MAX_VISIBLE_PAGES - 1)
  if (endPage - startPage < MAX_VISIBLE_PAGES - 1) startPage = Math.max(0, endPage - MAX_VISIBLE_PAGES + 1)

  const prevDisabled = page <= 0
  const nextDisabled = page >= totalPages - 1
  const goTo = (event, newPage) => onChangePage && onChangePage(event, newPage)

  const pages = []
  for (let i = startPage; i <= endPage; i++) {
    pages.push(
      <S.PageBox key={i} type="button" active={i === page} onClick={e => i !== page && goTo(e, i)}>
        {i + 1}
      </S.PageBox>
    )
  }

  const from = count === 0 ? 0 : page * rowsPerPage + 1
  const to = Math.min((page + 1) * rowsPerPage, count)
  const localization = (i18n.tableLocalization && i18n.tableLocalization.pagination) || {}
  const renderValue = (SelectProps && SelectProps.renderValue) || (value => `${value} ${localization.labelRowsSelect || ''}`)
  const displayedRows = labelDisplayedRows || (({ from, to, count }) =>
    (localization.labelDisplayedRows || '{from}-{to} / {count}').replace('{from}', from).replace('{to}', to).replace('{count}', count))

  return (
    <S.Cell colSpan={1000}>
      <S.Wrapper>
        {totalPages > 1 && (
          <S.Pager>
            <S.ArrowBox type="button" disabled={prevDisabled} onClick={e => !prevDisabled && goTo(e, page - 1)}>
              <ChevronLeft fontSize="small" />
            </S.ArrowBox>
            {pages}
            <S.ArrowBox type="button" disabled={nextDisabled} onClick={e => !nextDisabled && goTo(e, page + 1)}>
              <ChevronRight fontSize="small" />
            </S.ArrowBox>
          </S.Pager>
        )}

        <S.Right>
          {rowsPerPageOptions && rowsPerPageOptions.length > 1 && (
            <Select
              value={rowsPerPage}
              onChange={onChangeRowsPerPage}
              disableUnderline
              renderValue={renderValue}
              className="rows-per-page"
              MenuProps={{ getContentAnchorEl: null, anchorOrigin: { vertical: 'top', horizontal: 'left' }, transformOrigin: { vertical: 'bottom', horizontal: 'left' } }}
            >
              {rowsPerPageOptions.map(option => (
                <MenuItem key={option} value={option}>{option}</MenuItem>
              ))}
            </Select>
          )}
          {count > 0 && <S.Range>{displayedRows({ from, to, count })}</S.Range>}
        </S.Right>
      </S.Wrapper>
    </S.Cell>
  )
}

MTPagination.propTypes = {
  count: PropTypes.number,
  page: PropTypes.number,
  rowsPerPage: PropTypes.number,
  rowsPerPageOptions: PropTypes.array,
  onChangePage: PropTypes.func,
  onChangeRowsPerPage: PropTypes.func,
  labelDisplayedRows: PropTypes.func,
  SelectProps: PropTypes.object
}

MTPagination.defaultProps = {
  count: 0,
  page: 0,
  rowsPerPage: 20,
  rowsPerPageOptions: []
}

export default MTPagination
